import React from 'react'
import './EVFooterBottom.css'

const EVFooterBottom: React.FC = () => {
  return (
    <div className="ev-footer-bottom">
      <div className="ev-footer-copyright">
        <span>© 2026 EliteDrive Luxury Chauffeur Service. All rights reserved.</span>
        <span className="ev-footer-dev">
          Developed by <a href="https://www.kaizentech.co.za" target="_blank" rel="noopener noreferrer" className="ev-footer-dev-link">Kaizen Technology</a>
        </span>
      </div>

      <div className="ev-footer-legal">
        <a href="#terms" className="ev-footer-legal-link">
          Terms & Conditions
        </a>
        <a href="#privacy" className="ev-footer-legal-link">
          Privacy Policy
        </a>
      </div>
    </div>
  )
}

export default EVFooterBottom
